export default {
  respurchase_report: "Purchase Report",
  resloading_purchase_report: "Loading purchase report...",

  restotal_purchase: "Total Purchase",
  restotal_orders: "Total Orders",
  restotal_quantity: "Total Quantity",
  ressuppliers: "Suppliers",

  ressearch_purchase: "Search Order / Product / Supplier...",
  resall_status: "All Status",
  resall_suppliers: "All Suppliers",

  resdelivered: "Delivered",
  respending: "Pending",
  rescancelled: "Cancelled",

  resorder_id: "Order ID",
  resdate: "Date",
  ressupplier: "Supplier",
  resproduct: "Product",
  resqty: "Qty",
  resamount: "Amount",
  resstatus: "Status",

  resno_data_found: "No data found",

  resprev: "Prev",
  resnext: "Next",
  respage: "Page",
  resof: "of",
  "resorder_id": "Order ID",
  "resorder_date": "Order Date",
  "resexpected_delivery": "Expected Delivery",
  "ressupplier": "Supplier",
  "resstatus": "Status",
  "respayment_status": "Payment Status",
  "respayment_method": "Payment Method",

  "resitems": "Items",
  "resproduct": "Product",
  "resqty": "Quantity",
  "resprice": "Price",
  "resdiscount": "Discount",
  "resamount": "Amount",

  "restotal": "Total",
  "respaid": "Paid",
  "resdue": "Due",

  "resremarks": "Remarks",
  "resclose": "Close",

  "resdownload_excel": "Download Excel",
  "resdownload_pdf": "Download PDF",

  "resaction": "Action",
  "resview": "View",

  "resno_data_found": "No data found",
  "resno_recent_orders": "No recent orders",

  "resitems_count": "Items",
  "resorder_summary": "Order Summary"

};